"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/subproject/wizard");
//#endregion
//#region INITIAL STATE
exports.initialState = {
    step: 0,
    errors: null,
    status: 'STANDBY',
    name: '',
    notifyFollowing: '',
    project: null,
    categories: {},
    metas: {}
};
//#endregion
//#region LENS
const stepLens = monocle.Lens.fromProp('step');
const errorsLens = monocle.Lens.fromProp('errors');
const statusLens = monocle.Lens.fromProp('status');
const nameLens = monocle.Lens.fromProp('name');
const notifyFollowingLens = monocle.Lens.fromProp('notifyFollowing');
const projectLens = monocle.Lens.fromProp('project');
const categoriesLens = monocle.Lens.fromProp('categories');
const metasLens = monocle.Lens.fromProp('metas');
//#endregion
//#region REDUCER
const methods = {};
exports.methods = methods;
methods[ActionTypes.STEP_VALIDATION_SUCCESS] = (state, action) => stepLens.set(action.payload)(state);
methods[ActionTypes.STEP_VALIDATION_FAILED] = (state, action) => errorsLens.set(action.payload.reduce((rv, e) => {
    ;
    (rv[e.key] = rv[e.key] || []).push(e.value);
    return rv;
}, {}))(state);
methods[ActionTypes.SAVE_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
methods[ActionTypes.SAVE_SUCCESS] = (state, action) => statusLens.set('FETCHED')(state);
methods[ActionTypes.SAVE_FAILED] = (state, action) => statusLens.set('FAILED')(state);
methods[ActionTypes.SET_PROJECT] = (state, action) => projectLens.set(action.payload)(state);
methods[ActionTypes.UPDATE_FIELD] = (state, action) => {
    switch (action.payload.key) {
        case 'name':
            return nameLens.set(action.payload.value)(state);
        case 'notifyFollowing':
            return notifyFollowingLens.set(action.payload.value)(state);
        default:
            return state;
    }
};
methods[ActionTypes.TOGGLE_CATEGORY] = (state, action) => categoriesLens.modify((x) => {
    const clone = Object.assign({}, x);
    for (const group of action.payload.groups) {
        if (action.payload.selected) {
            clone[group.id] = group;
        }
        else {
            delete clone[group.id];
        }
    }
    return clone;
})(state);
methods[ActionTypes.CHANGE_CATEGORY_NAME] = (state, action) => categoriesLens.modify((x) => {
    const update = x[action.payload.group.id];
    if (update) {
        const clone = Object.assign({}, x);
        const item = Object.assign({}, x[action.payload.group.id]);
        item.name = action.payload.groupName;
        clone[action.payload.group.id] = item;
        return clone;
    }
    return x;
})(state);
methods[ActionTypes.UPDATE_CUSTOMMETA] = (state, action) => metasLens.modify((oldMetas) => {
    const metas = Object.assign({}, oldMetas);
    metas[action.payload.identifier] = action.payload.value;
    return metas;
})(state);
methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//#endregion
//# sourceMappingURL=wizard.js.map